import { render, staticRenderFns } from "./index_v1.0.vue?vue&type=template&id=4d9d6ac5&scoped=true&"
import script from "./index_v1.0.vue?vue&type=script&lang=js&"
export * from "./index_v1.0.vue?vue&type=script&lang=js&"
import style0 from "./index_v1.0.vue?vue&type=style&index=0&id=4d9d6ac5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9d6ac5",
  null
  
)

export default component.exports